import {
    DomainRoundedIcon,
    EquipmentIcon,
    HorizontalSigningIcon,
    RoadworkIcon,
    RiskZonesIcon,
    RoadIcon,
    SectionIcon,
    VerticalSigningIcon,
} from "@l2r-front/l2r-icons"

import { I18N_NAMESPACE } from "./i18n"
import { LINEAR_LOCATION_END, LINEAR_LOCATION_START, TYPE_ID } from "./urlParams"

export const APP_DOCUMENT = "document"
export const MODULE_DOCUMENTS = "documents"
export const API_MODULE_DOCUMENT = "DOCUMENT"

export const NETWORK_ATTACHMENT = "network"
export const ROAD_ATTACHMENT = "road"
export const SECTION_ATTACHMENT = "section"
export const LINEAR_ATTACHMENTS = [ROAD_ATTACHMENT, SECTION_ATTACHMENT]


const APP_ROAD = "road"
const MODULE_ROADWORKS = "roadworks"
const API_MODULE_ROADWORKS = "ROADWORK"
export const ROADWORK_ATTACHMENT = "roadwork"

const APP_CITY = "city"
const MODULE_VERTICAL_SIGNING = "verticalSigning"
const API_MODULE_VERTICAL_SIGNING = "VERTICAL_SIGNING"

export const VERTICAL_SIGN_POLE_ATTACHMENT = "verticalsignpole"
const MODULE_HORIZONTAL_SIGNING = "horizontalSigning"
const API_MODULE_HORIZONTAL_SIGNING = "HORIZONTAL_SIGNING"
export const HORIZONTAL_SIGN_ATTACHMENT = "horizontalsign"
const MODULE_EQUIPMENT = "equipment"
export const EQUIPMENT_ATTACHMENT = "equipment"
const API_MODULE_EQUIPMENT = "EQUIPMENT"

const APP_SAFETY = "safety"
const MODULE_RISK_ZONES = "risk_zones"
export const RISK_ZONE_CLUSTER_ATTACHMENT = "riskzonecluster"
const API_MODULE_RISK_ZONE = "RISK_ZONE"

export const BASE_ATTACHMENTS = [NETWORK_ATTACHMENT, ROAD_ATTACHMENT, SECTION_ATTACHMENT]

export const ModulesInfo = {
    [NETWORK_ATTACHMENT]: {
        color: "_components/pin/gestion_documentaire/referentiel/enabled",
        getDetailsRoute: () => `attached/${NETWORK_ATTACHMENT}`,
        getDetailsTitle: (t) => t(I18N_NAMESPACE, "components.documentListItem.network"),
        labelKey: "components.documentListItem.network",
        module: API_MODULE_DOCUMENT,
        icon: DomainRoundedIcon,
        order: 0,
    },
    [ROAD_ATTACHMENT]: {
        color: "_components/pin/gestion_documentaire/referentiel/enabled",
        getDetailsRoute: () => `attached/${ROAD_ATTACHMENT}`,
        getDetailsTitle: (t) => t(I18N_NAMESPACE, "components.documentListItem.road"),
        labelKey: "components.documentListItem.road",
        icon: RoadIcon,
        module: API_MODULE_DOCUMENT,
        queryUrl: "geoserver/features",
        order: 1,
    },
    [SECTION_ATTACHMENT]: {
        color: "_components/pin/gestion_documentaire/referentiel/enabled",
        getDetailsRoute: (item) => {
            const linearLocation = JSON.parse(item.linearLocation)[0]
            return `attached/${SECTION_ATTACHMENT}?${LINEAR_LOCATION_START}=${linearLocation.start}&${LINEAR_LOCATION_END}=${linearLocation.end}&${TYPE_ID}=${linearLocation.typeid}`
        },
        getDetailsTitle: (t) => t(I18N_NAMESPACE, "components.documentListItem.section"),
        labelKey: "components.documentListItem.section",
        module: API_MODULE_DOCUMENT,
        icon: SectionIcon,
        order: 2,
    },
    [VERTICAL_SIGN_POLE_ATTACHMENT]: {
        color: "_components/pin/gestion_documentaire/city/enabled",
        getDetailsRoute: (item) => `attached/${item.attached_object_content_type}/${item.attached_object_uuid}`,
        getItemModuleRoute: (road, itemId) => `${APP_CITY}/${MODULE_VERTICAL_SIGNING}/${road}/${itemId}`,
        getDetailsTitle: (t, _, type, elementTypes) => {
            if (elementTypes) {
                const is_multi = elementTypes.is_multi ||
                    (elementTypes.vertical_signs.length > 1 && (elementTypes.vertical_signs.every(sign => !sign.is_main) || elementTypes.vertical_signs.filter(sign => sign.is_main).length > 1))
                return is_multi ? t(I18N_NAMESPACE, "components.documentListItem.verticalSigns")
                    : elementTypes.vertical_signs.find(sign => sign.is_main)?.name || elementTypes.vertical_signs[0].name
            } else {
                return type?.name || t(I18N_NAMESPACE, "components.documentListItem.verticalSign")
            }
        },
        labelKey: "components.documentListItem.verticalSign",
        icon: VerticalSigningIcon,
        queryUrl: "vertical_signing/vertical_sign_poles",
        typeUrl: "vertical_signing/vertical_sign_types",
        getElementType: (element, elementTypes) => ({
            ...element,
            vertical_signs: element?.vertical_signs?.map(el => ({
                ...el,
                ...elementTypes.find(type => type?.code === el.vertical_sign_type),
            })),
        }) || null,
        module: API_MODULE_VERTICAL_SIGNING,
        order: 4,
    },
    [HORIZONTAL_SIGN_ATTACHMENT]: {
        color: "_components/pin/gestion_documentaire/city/enabled",
        getDetailsRoute: (item) => `attached/${item.attached_object_content_type}/${item.attached_object_uuid}`,
        getItemModuleRoute: (road, itemId) => `${APP_CITY}/${MODULE_HORIZONTAL_SIGNING}/${road}/${itemId}`,
        getDetailsTitle: (t, _element, type) => type?.name || t(I18N_NAMESPACE, "components.documentListItem.horizontalSign"),
        labelKey: "components.documentListItem.horizontalSign",
        icon: HorizontalSigningIcon,
        queryUrl: "horizontal_signing/horizontal_signs",
        typeUrl: "horizontal_signing/horizontal_sign_types",
        getElementType: (element) => element?.horizontal_sign_type || null,
        module: API_MODULE_HORIZONTAL_SIGNING,
        order: 5,
    },
    [EQUIPMENT_ATTACHMENT]: {
        color: "_components/pin/gestion_documentaire/city/enabled",
        getDetailsRoute: (item) => `attached/${item.attached_object_content_type}/${item.attached_object_uuid}`,
        getItemModuleRoute: (road, itemId) => `${APP_CITY}/${MODULE_EQUIPMENT}/${road}/${itemId}`,
        getDetailsTitle: (t, _element, type) => type?.name || t(I18N_NAMESPACE, "components.documentListItem.equipment"),
        labelKey: "components.documentListItem.equipment",
        icon: EquipmentIcon,
        queryUrl: "equipment/equipments",
        typeUrl: "equipment/equipment_types",
        getElementType: (element) => element?.equipment_type || null,
        module: API_MODULE_EQUIPMENT,
        order: 6,
    },
    [RISK_ZONE_CLUSTER_ATTACHMENT]: {
        color: "_components/pin/gestion_documentaire/security/enabled",
        getDetailsRoute: (item) => `attached/${item.attached_object_content_type}/${item.attached_object_uuid}`,
        getItemModuleRoute: (road, _itemId, item) => `${APP_SAFETY}/${MODULE_RISK_ZONES}/${road}/${item?.risk_zone?.identifier}`,
        getDetailsTitle: (t) => t(I18N_NAMESPACE, "components.documentListItem.riskZone"),
        labelKey: "components.documentListItem.riskZone",
        icon: RiskZonesIcon,
        queryUrl: "risk_zone/risk_zone_clusters",
        module: API_MODULE_RISK_ZONE,
        order: 7,
    },
    [ROADWORK_ATTACHMENT]: {
        color: "_components/pin/gestion_documentaire/road/enabled",
        getDetailsRoute: (item) => `attached/${item.attached_object_content_type}/${item.attached_object_uuid}`,
        getItemModuleRoute: (road, itemId) => `${APP_ROAD}/${MODULE_ROADWORKS}/${road}/${itemId}`,
        getDetailsTitle: (t) => t(I18N_NAMESPACE, "components.documentListItem.roadwork"),
        labelKey: "components.documentListItem.roadwork",
        icon: RoadworkIcon,
        queryUrl: "roadwork/roadworks",
        module: API_MODULE_ROADWORKS,
        order: 3,
    },
}